import '../scss/main.scss';

import ObjectFitImages from 'object-fit-images';
import HandelModal from './components/Modal';
import Menu from './components/Menu';
import ProductGrid from './components/ProductGrid';
import Accordion from './components/Accordion';
import ShowMore from './components/ShowMore';
import ScrollTo from './components/ScrollTo';
import Counter from './components/Counter';
import ProductInfo from './components/ProductInfo';
import Score from './components/Score';
import Helpers from "./components/Helpers";
import InfoBar from "./components/InfoBar";
import Ares from "./components/Ares";
import OrderCart from "./components/OrderCart";
import SliderScrolling from "./components/SliderScrolling";
import Banner from "./components/Banner";
import Popup from "./components/Popup";
import YearCount from "./components/YearCount";
import AddToCartAnimation from "./components/AddToCartAnimation";

window.addEventListener('DOMContentLoaded', (event) => {
    Menu.init();
    HandelModal.init();
    HandelModal.a11y();
    ProductGrid.init();
    Accordion.init();
    ShowMore.init();
    ShowMore.hiddenItems();
    ScrollTo.init();
    Counter.init();
    ProductInfo.init();
    ProductInfo.scrollToProductInfo();
    ProductInfo.handleExternalTriggers();
    Score.init();
    Helpers.handleCheckboxes();
    InfoBar.init();
    Ares.init();
    OrderCart.init();
    SliderScrolling.init();
    Banner.init();
    ObjectFitImages();
    Popup.init();
    Helpers.handleClosers();
    YearCount.init();
    AddToCartAnimation.init();
});
